import config from '@/config/config'
import axios from 'axios'

export default {
    state: {
        currentGroup: null,
        groups: [],
        groupMembership: [],
        loadingGroup: true
    },
    getters: {
        currentGroup: state => state.currentGroup
    },
    mutations: {
        setGroup (state, payload) {
            state.currentGroup = payload
        },
        setGroups (state, payload) {
            state.groups = payload
        },
        setGroupMembership (state, payload) {
            state.groupMembership = payload
        },
        setPendingActions (state, payload) {
            state.pendingActions = payload
        },
        setLoadingGroup (state, payload) {
            state.loadingGroup = payload
        }
    },
    actions: {
        getGroupData ({commit}, group) {
            axios.get(config.apiUrl() + 'group/getOptions/' + group).then(response => {
                commit('setGroup', response.data)
            }, err => {
                commit('setGroup', [])
            })
        },
        getGroups ({commit}) {
            commit('setGroups', [])
            commit('setLoadingGroup', true)
            axios.get(config.apiUrl() + 'group/getGroup').then(response => {
                commit('setGroups', response.data)
                commit('setLoadingGroup', false)
            }, err => {
                commit('setGroups', [])
                commit('setLoadingGroup', false)
            })
        },
        // // This is also under producer store
        // getGroupMembership ({commit}, group) {
        //     commit('setGroupMembership', [])
        //     axios.get(config.apiUrl() + 'group/getGroup/' + group + '/membership').then(response => {
        //         commit('setGroupMembership', response.data)
        //     }, err => {
        //         commit('setGroupMembership', [])
        //     })
        // },
    }
}
